import React from "react";
import "./WhyChooseUs.css";
import { FaPlane, FaClipboardCheck, FaHeadset } from "react-icons/fa";

const features = [
  {
    icon: <FaPlane />,
    title: "Extensive Flight Search",
    text: "Explore a comprehensive range of flight options from leading airlines worldwide. Our user-friendly interface allows you to effortlessly search and book flights tailored to your clients' needs.",
  },
  {
    icon: <FaClipboardCheck />,
    title: "Efficient Booking System",
    text: "Our streamlined booking system makes the reservation process quick and efficient. Spend less time navigating complex interfaces and more time catering to your clients' travel preferences.",
  },
  {
    icon: <FaHeadset />,
    title: "24/7 Support",
    text: "We prioritize your success. Our dedicated support team is available around the clock to assist you with any queries or concerns. Count on us for prompt and reliable assistance.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="whyUs">
      {/* Hero */}
      <div className="whyUs-hero">
        <h2>Why Choose AbasinExpress?</h2>
        <p>
          Take your travel agency to new heights with{" "}
          <strong>AbasinExpress</strong>. Sign up now and experience the ease
          and efficiency of our B2B travel portal. Elevate your business, exceed
          your clients' expectations, and embrace a future of limitless
          possibilities.
        </p>
      </div>

      {/* Features */}
      <div className="whyUs-feature-list">
        {features.map((f, i) => (
          <div className="whyUs-feature" key={i}>
            <div className="whyUs-icon">{f.icon}</div>
            <div>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div className="whyUs-cta">
        <a
          href="https://wa.me/93779897682"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button>Talk to Our Experts</button>
        </a>
      </div>
    </section>
  );
};

export default WhyChooseUs;
